import { DataTableSkeleton, SkeletonText } from '@carbon/react';
import { useTranslation } from '@pos/i18n';

/** A table-shaped skeleton while a list or table of a tab loads. */
export function TableLoading({ columns, label }: { columns: number; label: string }) {
  return (
    <DataTableSkeleton columnCount={columns} rowCount={5} showHeader={false} showToolbar={false} aria-label={label} />
  );
}

/** A few lines of skeleton text, for a list inside a dialog. */
export function ListLoading() {
  const { t } = useTranslation();
  return (
    <div role="status" aria-busy="true" aria-label={t('common.loading')}>
      <SkeletonText paragraph lineCount={4} />
    </div>
  );
}
